/* Add-ons, condensed (2026-10-18): after a successful add from the add-ons block, its "+" button shows a check and "Added" for 2 s
   and the block's status line announces it. Success is the theme's own cartUpdate event (published by product-form.js only when
   /cart/add succeeds), matched to the button that was just pressed. The add itself and the cart drawer are product-form.js, unchanged. */
(function () {
  if (window.elyAddonsCompact) return;
  window.elyAddonsCompact = true;
  var pending = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.ely-addons--compact')) return;
    pending = form.querySelector('[data-ely-addon-add]');
  }, true);
  function onAdded(evt) {
    if (!pending || !evt || evt.source !== 'product-form') return;
    var btn = pending;
    if (String(evt.productVariantId) !== btn.getAttribute('data-ely-addon-add')) return;
    pending = null;
    clearTimeout(btn._elyAddedTimer);
    btn.setAttribute('data-added', '');
    var status = btn.closest('.ely-addons--compact').querySelector('[data-ely-addons-status]');
    var name = (btn.getAttribute('aria-label') || '').replace(/^Add /, '');
    if (status) status.textContent = name + ' added to cart';
    btn._elyAddedTimer = setTimeout(function () {
      btn.removeAttribute('data-added');
      if (status) status.textContent = '';
    }, 2000);
  }
  function hook() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, onAdded);
    return true;
  }
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();
